import React from "react";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import "../../styles/brand.css";
import IsoStandards from "./IsoStandards";
import IsoProcess from "./IsoProcess";
import IsoWhyChoose from "./IsoWhyChoose";
import IsoIndustries from "./IsoIndustries";
import {
  finalCtaContent,
  heroContent,
  isoSeo,
  servicesContent,
} from "./isoContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${isoSeo.slug}`;

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: heroContent.h1,
    description: isoSeo.description,
    url: CANONICAL,
    serviceType: "ISO certification consultancy",
    provider: { "@type": "Organization", name: "MBA Solutions", url: SITE_URL },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: servicesContent.title,
      itemListElement: servicesContent.standards.map((standard) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: standard.title,
          description: standard.subtitle,
        },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: `${SITE_URL}/services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "ISO Certification Services",
        item: CANONICAL,
      },
    ],
  },
];

const IsoCertificationServices = () => (
  <Layout
    title={isoSeo.title}
    description={isoSeo.description}
    keywords="ISO certification consultancy, ISO 9001, ISO 14001, ISO 45001, ISO 22000, ISO 27001, ISO 50001, management system implementation, ISO consultant, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="iso-services-page brand-page bg-white">
      {/* the supplied banner, shown whole — never cropped */}
      <ImageBanner
        src="/assets/banners/ISOCertification-Services.jpeg"
        alt="ISO Certification Services — MBA Solutions"
        width={1862}
        height={560}
        whole
      />
      <PageIntro
        id="iso-services-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <IsoStandards />
      <IsoProcess />
      <IsoWhyChoose />
      <IsoIndustries />
      <FinalCtaPanel
        id="iso-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default IsoCertificationServices;
